import { useState, ViewTransition } from 'react';

import { useCacheKey } from '@libs/common-next';
import { CacheKey as Ck } from '@libs/vercel';

import css from './cache-key.module.scss';
import { config, type Id } from './config';
import { Contributors } from './contributors';
import { Details } from './details';
import { Status } from './status';

export function CacheKey() {
    const ck = useCacheKey();
    const [value, setValue] = useState(ck.key);
    const [selected, setSelected] = useState<Id>('device');
    const sections = config(Ck.decode(value));

    return (
        <ViewTransition name="container">
            <div className={css.wrapper}>
                <Status value={value} onRefresh={() => setValue(ck.key)} />

                <div className={css.grid}>
                    <Contributors sections={sections} selected={selected} onSelect={setSelected} />
                    <Details value={value} onChange={setValue} section={sections[selected]} onSelect={setSelected} />
                </div>
            </div>
        </ViewTransition>
    );
}
